import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Theme,
    Typography,
} from '@mui/material';
import { createStyles, withStyles } from '@mui/styles';
import { ReactElement, useState } from 'react';
import AquantCancelIcon from '../resources/images/dialog-cancel.svg';
import './Wizard.scss';

export interface ConfirmationDialogProps {
    onClose: () => void;
    closeLabel?: string;
    onYes?: () => void;
    yesLabel?: string;
    onNo?: () => void;
    noLabel?: string;
    title?: string;
    content?: ReactElement;
}

export const defaultConfirmationDialogProps: ConfirmationDialogProps = {
    onClose: () => {},
};

export interface StepConfirmationProps {
    confirmationDialogs: ConfirmationDialogProps[];
    finish: () => void;
    cancel: () => void;
}

export const DialogCard = withStyles((theme: Theme) =>
    createStyles({
        paper: {
            borderRadius: '14px ',
        },
    }),
)(Dialog);

const StepConfirmation = ({ confirmationDialogs, finish, cancel }: StepConfirmationProps) => {
    const [currentDialog, setCurrentDialog] = useState(0);

    const advance = () => {
        if (currentDialog === confirmationDialogs.length - 1) {
            finish();
        } else {
            setCurrentDialog(currentDialog + 1);
        }
    };

    const extendedDialog: ConfirmationDialogProps = {
        ...confirmationDialogs[currentDialog],
        onYes: () => {
            if (confirmationDialogs[currentDialog].onYes) {
                confirmationDialogs[currentDialog].onYes!();
            }
            advance();
        },
        onClose: () => {
            confirmationDialogs[currentDialog].onClose();
            setCurrentDialog(0);
            cancel();
        },
        onNo: () => {
            if (confirmationDialogs[currentDialog].onNo) {
                confirmationDialogs[currentDialog].onNo!();
            }
            advance();
        },
    };

    return (
        <DialogCard open onClose={extendedDialog.onClose}>
            <DialogTitle>
                <div style={{ display: 'flex', alignItems: 'center', flex: 5 }}>
                    <Typography variant="h3" style={{ flexGrow: 4 }}>
                        {' '}
                        {extendedDialog.title || 'Confirm'}{' '}
                    </Typography>
                    <img src={AquantCancelIcon} onClick={cancel} alt="cancel icon" style={{ marginLeft: 15 }} />
                </div>
            </DialogTitle>

            <Divider />

            <DialogContent>
                {extendedDialog.content ?? <DialogContentText>Please Confirm Action</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={extendedDialog.onClose}
                    style={{
                        backgroundColor: '#EAF0FF',
                        color: '#2468FF',
                        border: '1px solid #2468FF',
                        fontSize: '13px',
                        fontWeight: '400',
                        width: '73px',
                        height: '34px',
                    }}
                    sx={{ ':hover': { opacity: '0.7' } }}
                >
                    {' '}
                    {extendedDialog.closeLabel ?? 'Close'}{' '}
                </Button>
                {confirmationDialogs[currentDialog].onYes ? (
                    <Button
                        className="primaryBtn"
                        style={{
                            backgroundColor: '#2468FF',
                            color: '#F6F7F7',
                            fontSize: '13px',
                            fontWeight: '400',
                            width: '73px',
                            height: '34px',
                        }}
                        sx={{ ':hover': { opacity: '0.7' } }}
                        onClick={extendedDialog.onYes}
                    >
                        {extendedDialog.yesLabel ?? 'Yes'}
                    </Button>
                ) : null}
                {confirmationDialogs[currentDialog].onNo ? (
                    <Button
                        onClick={extendedDialog.onNo}
                        style={{
                            backgroundColor: '#ffff',
                            color: '#2468FF',
                            fontSize: '13px',
                            fontWeight: '400',
                            width: '73px',
                            height: '34px',
                        }}
                        sx={{ ':hover': { opacity: '0.7' } }}
                    >
                        {extendedDialog.noLabel ?? 'No'}
                    </Button>
                ) : null}
            </DialogActions>
        </DialogCard>
    );
};

export default StepConfirmation;
